<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :disabled="disable"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template #activator="{ on }">
      <v-text-field
        :value="time"
        prepend-icon="access_time"
        :label="label"
        :readonly="readonly"
        :disabled="disable"
        type="time"
        v-on="on"
        @input="input"
        :error-messages="validator ? $errors(validator) : []"
      />
    </template>
    <v-time-picker
      v-if="menu"
      :value="time"
      format="24hr"
      full-width
      @input="input"
  /></v-menu>
</template>

<script>
export default {
  props: {
    value: String,
    disable: {
      type: Boolean,
      default: false,
    },
    label: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    validator: Object,
  },
  data() {
    return {
      time: this.value,
      menu: false,
    }
  },
  watch: {
    value(val) {
      this.time = val
    },
  },
  computed: {},
  methods: {
    input(event, closeMenu = true) {
      if (closeMenu) {
        this.menu = false
      }
      this.time = event
      this.$emit('input', event)
    },
  },
}
</script>
<style scoped>
.v-input {
  font-size: 12px;
}
</style>
